import { Text } from '@workos-inc/design-system';
import * as React from 'react';
type SubtitleProps = Omit<Extract<React.ComponentPropsWithoutRef<typeof Text>, {
  as: 'p';
}>, 'as'>;
export const Subtitle = React.forwardRef<HTMLParagraphElement, SubtitleProps>((props, forwardedRef) => <Text ref={forwardedRef} as="p" color="gray" id="page-subtitle" size="5" wrap="pretty" {...props} />);
Subtitle.displayName = 'Subtitle';